export const eur = (v) =>
    new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", maximumFractionDigits: 2 }).format(v || 0);

/**
 * Kompakte EUR-Anzeige für KPI-Kacheln. Skaliert ab 1 Mio. automatisch zu „Mio. €" / „Mrd. €".
 * < 10.000:        2.345,67 €      (volle Anzeige)
 * < 1 Mio.:        234.567 €       (ohne Cent)
 * < 1 Mrd.:        2,968 Mio. €    (3 Nachkommastellen)
 * ≥ 1 Mrd.:        1,234 Mrd. €    (3 Nachkommastellen)
 */
export const eurKompakt = (v) => {
    const n = Number(v) || 0;
    const abs = Math.abs(n);
    if (abs < 10000) {
        return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", maximumFractionDigits: 2 }).format(n);
    }
    if (abs < 1_000_000) {
        return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
    }
    if (abs < 1_000_000_000) {
        return `${new Intl.NumberFormat("de-DE", { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(n / 1_000_000)} Mio. €`;
    }
    return `${new Intl.NumberFormat("de-DE", { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(n / 1_000_000_000)} Mrd. €`;
};

export const num = (v) =>
    new Intl.NumberFormat("de-DE", { maximumFractionDigits: 0 }).format(v || 0);

export const pct = (v) =>
    new Intl.NumberFormat("de-DE", { style: "percent", maximumFractionDigits: 1 }).format((v || 0) / 100);

export const datum = (iso) => {
    if (!iso) return "—";
    try {
        return new Intl.DateTimeFormat("de-DE", { dateStyle: "short", timeStyle: "short" }).format(new Date(iso));
    } catch {
        return iso;
    }
};

/**
 * Berechnet den Bilanz-Stichtag aus zeitraum + zeitraum_typ:
 *   jahr "2025"              → "31.12.2025"
 *   halbjahr "2026/H1"       → "30.06.2026"
 *   halbjahr "2026/H2"       → "31.12.2026"
 *   quartal "2026/Q1..Q4"    → 31.03/30.06/30.09/31.12.2026
 * Fallback: gibt den rohen Zeitraum zurück.
 */
export const stichtag = (zeitraum, zeitraum_typ) => {
    if (!zeitraum) return "—";
    const raw = String(zeitraum);
    const m = raw.match(/^(\d{4})(?:[/\-]?([HhQq]?)(\d))?$/);
    if (!m) return raw;
    const year = m[1];
    const kind = (m[2] || "").toUpperCase();
    const idx = m[3] ? parseInt(m[3], 10) : null;

    const typ = (zeitraum_typ || "").toLowerCase();
    if (typ === "jahr" || (!idx && kind === "")) return `31.12.${year}`;
    if (kind === "H" || typ === "halbjahr") {
        return idx === 1 ? `30.06.${year}` : `31.12.${year}`;
    }
    if (kind === "Q" || typ === "quartal") {
        const map = { 1: `31.03.${year}`, 2: `30.06.${year}`, 3: `30.09.${year}`, 4: `31.12.${year}` };
        return map[idx] || `31.12.${year}`;
    }
    return `31.12.${year}`;
};
